<div mat-dialog-title>
  <h2>{{ 'confirm_prescription_title' | locale }}</h2>
</div>

<mat-dialog-content>
  <div class="text-container">
    <span
      >{{ 'confirm_prescription_text' | locale }}
      <mat-chip-set class="inline-chips">
        @if (archivedMedicineExists) {
          <mat-chip color="yellow">{{ 'archived_prescription_medicine' | locale }}</mat-chip>
        }
        @if (restrictedMedicineExists) {
          <mat-chip color="warn">{{ 'restricted_prescription_medicine' | locale }}</mat-chip>
        }
      </mat-chip-set>
    </span>
  </div>

  <div class="medicine-container">
    @for (medicine of medicines; track medicine; let last = $last) {
      <div class="medicine">
        <mat-icon svgIcon="capsule" [class]="medicine.isArchived ? 'yellow' : 'warn'"></mat-icon>
        <span>{{ medicine.active }}</span>
      </div>
      @if (!last) {
        <mat-divider></mat-divider>
      }
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button class="low no-fill" color="primary" mat-dialog-close>
    {{ 'edit' | locale }}
  </button>
  <button mat-flat-button color="primary" class="height-sm" [mat-dialog-close]="true">
    {{ 'confirm' | locale }}
    <mat-icon class="east" svgIcon="arrow-right"></mat-icon>
  </button>
</mat-dialog-actions>
